import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, TemplateRef, Type } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';
import { MyOverlayRef } from '../my-overlay-ref';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'aipb-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
  imports: [CommonModule, DragDropModule, OverlayModule, MatButtonModule, PortalModule, TranslocoPipe, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayComponent implements OnInit {
  // @ts-expect-error foo
  contentType: 'template' | 'string' | 'component';
  // @ts-expect-error foo
  content: string | TemplateRef<any> | Type<any>;
  // @ts-expect-error foo
  context;

  styles: Record<string, number | string> = {
    'max-width.px': 600,
    'max-height.px': 600
  };

  private document = inject(DOCUMENT);

  constructor(private ref: MyOverlayRef) {}

  get dragPosition$() {
    return this.ref.dragPosition$;
  }

  get title() {
    return this.ref.title || 'Overlay Title';
  }

  close() {
    this.ref.close(null);
  }

  minimize() {
    this.ref.minimize(this.document);
  }

  ngOnInit() {
    this.content = this.ref.content;

    if (typeof this.content === 'string') {
      this.contentType = 'string';
    } else if (this.content instanceof TemplateRef) {
      this.contentType = 'template';
      this.context = {
        close: this.ref.close.bind(this.ref)
      };
    } else {
      this.contentType = 'component';
    }
  }

  onMoveToFront() {
    this.ref.moveToFront(this.document);
  }

  smallOverlay() {
    this.styles = {
      width: 50 + 'vw',
      height: 50 + 'vh'
    };
  }

  mediumOverlay() {
    this.styles = {
      width: 50 + 'vw',
      height: 100 + 'vh'
    };
  }

  largeOverlay() {
    this.styles = {
      width: 100 + 'vw',
      height: 100 + 'vh'
    };
  }
}
